import { ArrowRight, X } from "lucide-react";
import { logoSymbol } from "@/data";
import { useBooking } from "@/context/BookingContext";

export default function BookingModal() {
  const { bookingOpen, closeBooking, modalCloseRef } = useBooking();
  if (!bookingOpen) return null;
  return (
    <div className="modal-backdrop" onClick={closeBooking} data-testid="booking-modal-backdrop">
      <div className="booking-modal soon-modal" role="dialog" aria-modal="true" aria-labelledby="modal-heading" onClick={(e) => e.stopPropagation()} data-testid="booking-modal">
        <button ref={modalCloseRef} className="modal-close" onClick={closeBooking} aria-label="Close" data-testid="booking-modal-close">
          <X />
        </button>
        <img src={logoSymbol} alt="" aria-hidden="true" className="soon-modal-mark" />
        <p className="eyebrow center">
          <ArrowRight size={13} /> Booking online
        </p>
        <h2 id="modal-heading">
          Something wonderful <em>is coming.</em>
        </h2>
        <p className="soon-modal-note">Online booking for The Vanda is launching soon. We're putting the finishing touches on your stay — thank you for your patience.</p>
        <button className="btn btn-primary" onClick={closeBooking} data-testid="booking-submit">
          Close
        </button>
      </div>
    </div>
  );
}
